/*
In content navigation component
*/
import Blue from '~/core';
import Swiper, { Pagination, Navigation } from 'swiper';

new Blue({
  name: 'Carousel',
  selector: '.carousel--swiper',
  setup(carousel) {
    Swiper.use([Pagination, Navigation]);
    const swiper = new Swiper(carousel, {
        // Optional parameters
        direction: 'horizontal',
        loop: true,
      
        // If we need pagination
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
      });
  }
})